import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystaonrentinmumbai() {



const cardData = {
  keyword: " Innova Crysta On Rent in Mumbai ",

headingDescription: "Velocity Cab provides reliable and comfortable Innova Crysta on rent in Mumbai, offering a premium travel experience for families, corporate groups, airport transfers, weddings, and outstation journeys. Our well-maintained Toyota Innova Crysta vehicles feature spacious seating, powerful performance, and ample luggage space, making them ideal for long-distance and city travel. With professional drivers, punctual service, and smooth ride quality, we ensure a stress-free journey across Mumbai and beyond. We offer flexible booking options including hourly rentals, full-day packages, one-way trips, and customized travel plans with transparent pricing and no hidden charges. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Innova Crysta rental in Mumbai.",

topPlaces: [
  {
    title: "Karjat",
    description: "Karjat is a scenic destination near Mumbai known for its lush greenery, rivers, trekking trails, and peaceful resorts. Travelers booking a sedan cab can enjoy a relaxing drive while exploring waterfalls, ancient caves, and beautiful countryside landscapes."
  },
  {
    title: "Kamshet",
    description: "Kamshet is a popular adventure destination famous for paragliding, rolling hills, and picturesque lakes. Visitors can experience thrilling flights, nature walks, and breathtaking views of the Western Ghats."
  },
  {
    title: "Daman",
    description: "Daman is a coastal town known for its tranquil beaches, Portuguese architecture, and historic forts. Travelers can explore Devka Beach, Jampore Beach, and colonial-era churches while enjoying a peaceful seaside getaway."
  },
  {
    title: "Silvassa",
    description: "Silvassa is the capital of Dadra and Nagar Haveli, offering lush gardens, wildlife attractions, museums, and tribal culture. It is an ideal destination for nature lovers and families seeking a refreshing vacation."
  },
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a revered pilgrimage destination famous for one of the twelve Jyotirlingas of Lord Shiva. Visitors can seek blessings at the ancient temple while enjoying the scenic surroundings of the Brahmagiri Hills."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is a renowned pilgrimage site and wildlife sanctuary nestled in the Sahyadri Hills. It is known for its Jyotirlinga Temple, dense forests, and trekking opportunities, making it perfect for spiritual and nature enthusiasts."
  },
  {
    title: "Chiplun",
    description: "Chiplun is a picturesque town in the Konkan region surrounded by rivers, hills, and lush greenery. Travelers can visit the famous Parshuram Temple and enjoy the region's natural beauty and peaceful atmosphere."
  },
  {
    title: "Velas",
    description: "Velas is a charming coastal village famous for its Olive Ridley Turtle Festival and pristine beaches. Nature lovers can witness turtle conservation efforts and enjoy an eco-friendly getaway."
  },
  {
    title: "Malshej Ghat",
    description: "Malshej Ghat is a breathtaking mountain pass known for waterfalls, misty valleys, and rich biodiversity. It is a favorite destination for monsoon road trips, birdwatching, and scenic photography."
  },
  {
    title: "Ratnagiri",
    description: "Ratnagiri is a beautiful coastal city known for its beaches, historic forts, Alphonso mango orchards, and cultural heritage. Visitors can explore Ratnadurg Fort, Ganeshgule Beach, and enjoy the region's scenic Konkan coastline."
  }
],



services: [
{
name: "Innova Crysta on Rent Mumbai",
description: "Innova Crysta on rent Mumbai offers a premium and comfortable travel experience for families, corporate travelers, and group journeys. Known for its spacious seating, smooth suspension, and luxury interiors, the Innova Crysta is one of the most preferred vehicles for both city and outstation travel. This service is ideal for airport transfers, business meetings, family trips, and long-distance journeys from Mumbai. Professional drivers ensure safe driving and timely pickups, making every trip stress-free and reliable. Customers can choose flexible rental options including hourly, daily, and outstation packages based on their needs. Pickup is available from all major locations including Mumbai Airport, railway stations, and residential areas. With transparent pricing and easy booking, this service ensures comfort, convenience, and a premium travel experience."
},
{
name: "Toyota Innova Crysta Rental Mumbai",
description: "Toyota Innova Crysta rental Mumbai provides a reliable and luxurious travel option with well-maintained vehicles and experienced drivers. This service is suitable for family travel, corporate use, and special occasions where comfort is a priority. The vehicle offers spacious seating, ample luggage space, and smooth ride quality for long journeys. Professional chauffeurs ensure safe and punctual service across all routes. Flexible booking options allow customers to plan their travel as per convenience. It is one of the most trusted choices for premium cab services in Mumbai."
},
{
name: "Innova Crysta Cab Service Mumbai",
description: "Innova Crysta cab service Mumbai offers high-quality transportation with a focus on comfort, safety, and reliability. This service is ideal for airport transfers, city travel, and outstation trips. The vehicle’s premium interiors and spacious design ensure a relaxing journey for passengers. Professional drivers provide smooth navigation through city traffic and highways. Customers can enjoy flexible travel options and easy booking. It ensures a superior cab experience for all types of travelers."
},
{
name: "Innova Crysta Taxi Mumbai",
description: "Innova Crysta taxi Mumbai provides a comfortable and reliable travel solution for both local and outstation journeys. This service is perfect for families and business travelers who prefer spacious and premium vehicles. The taxi ensures smooth travel with excellent ride quality and safety features. Experienced drivers ensure timely pickups and drop-offs. Flexible booking options are available for different travel needs. It is a preferred option for luxury taxi services in Mumbai."
},
{
name: "7 Seater Innova Crysta Cab Mumbai",
description: "7 seater Innova Crysta cab Mumbai is ideal for families and small groups looking for spacious and comfortable travel. The vehicle offers ample legroom, comfortable seating, and sufficient luggage space for long trips. This service is suitable for airport transfers, city tours, and outstation travel. Professional drivers ensure safe and smooth journeys. Flexible rental options make it convenient for customers. It provides a perfect balance of comfort and capacity."
},
{
name: "Innova Crysta Airport Pickup Mumbai",
description: "Innova Crysta airport pickup Mumbai offers reliable and comfortable airport transfer services with timely pickups and drops. This service is ideal for travelers who prefer a premium vehicle for airport travel. Drivers track flight schedules to ensure punctual service. Spacious seating and luggage space make it suitable for families and groups. Clean and well-maintained vehicles enhance the travel experience. It ensures a hassle-free airport transfer."
},
{
name: "Cheap Innova Crysta on Rent Mumbai",
description: "Cheap Innova Crysta on rent Mumbai provides budget-friendly options for premium travel without compromising on comfort and safety. This service is ideal for cost-conscious travelers who want luxury at affordable rates. Well-maintained vehicles and professional drivers ensure smooth travel. Transparent pricing ensures no hidden charges. Flexible rental plans are available for different needs. It is a perfect combination of affordability and luxury."
},
{
name: "Innova Crysta for Outstation Mumbai",
description: "Innova Crysta for outstation Mumbai offers long-distance travel solutions with comfort and reliability. This service is ideal for trips to destinations like Pune, Lonavala, Nashik, Shirdi, and Goa. The vehicle provides a smooth ride with spacious interiors for long journeys. Professional drivers ensure safe driving on highways and ghat roads. Flexible packages include one way and round trip options. It ensures a comfortable and stress-free travel experience."
},
{
name: "Innova Crysta with Driver Mumbai",
description: "Innova Crysta with driver Mumbai provides a complete travel solution with experienced chauffeurs ensuring safe and comfortable journeys. Drivers are well-trained and familiar with city and highway routes for smooth navigation. This service allows customers to relax and enjoy their trip without worrying about driving. Flexible rental options are available for different travel needs. Clean and well-maintained vehicles enhance the experience. It ensures a premium and stress-free journey."
},
{
name: "Book Innova Crysta Cab Mumbai",
description: "Book Innova Crysta cab Mumbai for quick and hassle-free reservations with instant confirmation and flexible travel options. Customers can select vehicle type, travel date, and pickup location easily. Online booking platforms provide secure payment and transparent pricing. This service ensures availability of premium vehicles when needed. Dedicated support is available for assistance. It is the most convenient way to book a luxury cab in Mumbai."
},
{
name: "Innova Crysta Cab Booking Mumbai",
description: "Innova Crysta cab booking Mumbai allows customers to reserve premium cabs easily with flexible scheduling and instant confirmation. This service offers transparent pricing with no hidden charges. Customers can choose from various packages including hourly, daily, and outstation travel. Professional drivers ensure safe and reliable service. Online booking options make the process quick and convenient. It ensures a smooth and premium travel experience."
}
],

tableData: [
["Innova Crysta on Rent Mumbai","Toyota Innova Crysta Rental Mumbai"],
["Innova Crysta Cab Service Mumbai","Innova Crysta Taxi Mumbai"],
["7 Seater Innova Crysta Cab Mumbai","Innova Crysta Airport Pickup Mumbai"],
["Cheap Innova Crysta on Rent Mumbai","Innova Crysta for Outstation Mumbai"],
["Innova Crysta with Driver Mumbai","Book Innova Crysta Cab Mumbai"],
["Innova Crysta Cab Booking Mumbai","Innova Crysta Taxi Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Premium Innova Crysta Experience",
    WhyChoosedescription: "Velocity Cabs offers Innova Crysta on rent in Mumbai with luxurious interiors, spacious seating, and smooth suspension, making it ideal for family trips, corporate travel, and long-distance journeys."
  },
  {
    WhyChooseheading: "Experienced Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Mumbai city routes and highways, ensuring safe driving, smooth travel, and timely pickups and drop-offs."
  },
  {
    WhyChooseheading: "Transparent Rental Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent pricing for Innova Crysta rental in Mumbai. Customers receive complete fare details including per km charges, tolls, and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Rental Availability",
    WhyChoosedescription: "Our Innova Crysta rental service in Mumbai operates 24/7. Whether for airport transfers, business travel, or outstation trips, we ensure reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Sanitized AC Vehicles",
    WhyChoosedescription: "All Innova Crysta vehicles are fully air-conditioned, well maintained, and regularly sanitized to provide a safe and comfortable travel experience."
  },
  {
    WhyChooseheading: "Flexible Rental Options",
    WhyChoosedescription: "Velocity Cabs offers flexible rental options including local packages (8 hours/80 km), outstation trips, one-way travel, round-trip bookings, and customized plans."
  },
  {
    WhyChooseheading: "Ideal for Family & Corporate Travel",
    WhyChoosedescription: "Innova Crysta is perfect for families, corporate groups, airport transfers, and weddings with seating capacity for 6 to 7 passengers and ample luggage space."
  },
  {
    WhyChooseheading: "Trusted Car Rental Service in Mumbai",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for Innova Crysta on rent in Mumbai due to professional drivers, well-maintained vehicles, and reliable service quality."
  }
]
};

const faqData = [
  { question: "Do you provide Innova Crysta on rent in Mumbai?", answer: "Yes, Velocity Cabs provides premium Innova Crysta rental services in Mumbai for local and outstation travel." },
  { question: "What is the price of Innova Crysta on rent in Mumbai?", answer: "The rental cost typically ranges from ₹18 to ₹25 per km or ₹2500 to ₹4500 per day depending on the package and duration." },
  { question: "How many passengers can travel in Innova Crysta?", answer: "Innova Crysta can comfortably accommodate 6 to 7 passengers along with luggage." },
  { question: "Is Innova Crysta available for airport transfers?", answer: "Yes, we provide airport pickup and drop services in Mumbai using Innova Crysta vehicles." },
  { question: "Can I book Innova Crysta for outstation trips?", answer: "Yes, Innova Crysta is available for outstation travel from Mumbai to destinations like Pune, Shirdi, Goa, Mahabaleshwar, and Nashik." },
  { question: "Is rental service available 24 hours?", answer: "Yes, our Innova Crysta rental service in Mumbai operates 24/7." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all Innova Crysta vehicles are fully air-conditioned and well maintained." },
  { question: "Can I book Innova Crysta online?", answer: "Yes, customers can easily book Innova Crysta on rent in Mumbai online or through phone booking." },
  { question: "Is driver included in the rental?", answer: "Yes, all rentals include professional drivers for safe and comfortable travel." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rakesh Deshmukh",
    feedback:
      "Comfort level in the Innova Crysta during our Mumbai rental was outstanding. The vehicle was spacious, clean, and ideal for a long family journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "From the moment the vehicle arrived, the Innova Crysta impressed us with its premium feel and smooth ride quality throughout our Mumbai travel.",
    rating: 5
  }
];


























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const innovaCrystaMumbaiJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Innova Crysta On Rent in Mumbai | Velocity Cabs",
  "description": "Rent a Toyota Innova Crysta in Mumbai for airport pickups, outstation trips, or group travel. 7-seater AC options with driver available at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Innova Crysta Rental Packages in Mumbai",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Innova Crysta Rental",
        "description": "Rent an Innova Crysta for one-way travel in Mumbai with 7-seater AC options and private driver.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Innova Crysta Rental",
        "description": "Comfortable round-trip rental of Innova Crysta in Mumbai with private driver and 7-seater AC options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};





  return (
    <div>
      

<Helmet>
  <title>Innova Crysta On Rent in Mumbai | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Rent a Toyota Innova Crysta in Mumbai for airport pickups, outstation trips, or group travel. 7-seater AC options with driver available at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(innovaCrystaMumbaiJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/85.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystaonrentinmumbai;